import React, { Component, Fragment } from 'react';
import { Layout, Row, Col, Card, Icon, Alert } from 'antd';
import { withAsyncActions } from 'react-async-client';

import { getUser, getUserBilling } from 'actions/asyncActions';
import DictField from 'components/common/fields/DictField';
import ProfileUserForm from './ProfileUserForm';
import ProfileBillingForm from './ProfileBillingForm';
import RouteTitle from 'components/pages/RouteTitle.js';
import Breakpoint from 'components/layout/Breakpoint.js';

const initialState = {
    userEdit: false,
    billingEdit: false,
};

@withAsyncActions({
    getUser,
    getUserBilling: getUserBilling.withOptions({ dispatchOnMount: true }),
})
export default class Profile extends Component {
    state = initialState

    toogleEdit = (formName) => {
        this.setState(formName ? {
            [formName]: !this.state[formName]
        } : initialState);
    }

    onSuccess = () => {
        this.toogleEdit();
        this.props.getUser.refresh();
        this.props.getUserBilling.refresh();
    }

    isIndividual = () => {
        const { data: { user } } = this.props.getUser;
        return user.entity_type === 'INDIVIDUAL';
    }

    render() {
        const { userEdit, billingEdit } = this.state;
        const { data: { user } } = this.props.getUser;
        const { data: { billing_info }, meta } = this.props.getUserBilling;
       
        return (
            <Layout className="profile page container page-sm-no-m main-content">
                <Breakpoint min="lg">
                    <RouteTitle className="title-route title-page" />
                </Breakpoint>
                {user.phone_number && !user.is_confirmed ? <Alert message="Ваши данные получены, подождите одобрения администратора." type="info" /> : 
                     !user.is_confirmed ? 
                        <Alert message="Необходимо заполнить личные данные Вашего профиля." type="error" />
                        : null
                }
                <Row gutter={30}>
                    <Col className="form" md={12} sm={15} xs={24}>
                        <Card title="Личная информация:" bordered={false}>
                            <a className="profile-edit-button" onClick={() => this.toogleEdit('userEdit')}>
                                <Icon type='edit' /> Редактировать
                            </a>
                            { userEdit ? (
                                <ProfileUserForm
                                    initialValues={{
                                        ...user,
                                        files_ids: user.files.map(file => file.id)
                                    }}
                                    onSuccess={this.onSuccess}
                                />
                            ) : (
                                <Fragment>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Фамилия
                                        </Col>
                                        <Col xs={12}>
                                            {user.surname}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Имя
                                        </Col>
                                        <Col xs={12}>
                                            {user.name}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Отчество
                                        </Col>
                                        <Col xs={12}>
                                            {user.patronymic}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            E-mail
                                        </Col>
                                        <Col xs={12}>
                                            {user.email}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Телефон
                                        </Col>
                                        <Col xs={12}>
                                            {user.phone_number}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Тип уведомления
                                        </Col>
                                        <Col xs={12}>
                                            <DictField value={user.notification_type} dictionary='notification_type' />
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Страница в Facebook
                                        </Col>
                                        <Col xs={12}>
                                            {user.facebook}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Страница в Vkontakte
                                        </Col>
                                        <Col xs={12}>
                                            {user.vk}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Страница в Instagram
                                        </Col>
                                        <Col xs={12}>
                                            {user.instagram}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Образование
                                        </Col>
                                        <Col xs={12}>
                                            <DictField value={user.education_type} dictionary='education_type' />
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Учебное заведение
                                        </Col>
                                        <Col xs={12}>
                                            {user.institution}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Диплом
                                        </Col>
                                        <Col xs={12}>
                                            {user.files.map(file => (
                                                <div key={file.id}>
                                                    <a href={file.url} target="_blank">Скачать</a>
                                                </div>
                                            ))}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Тип юр. лица
                                        </Col>
                                        <Col xs={12}>
                                            <DictField value={user.entity_type} dictionary='entity_type' />
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Компания
                                        </Col>
                                        <Col xs={12}>
                                            {user.company}
                                        </Col>
                                    </Row>
                                </Fragment>
                            )}
                        </Card>
                    </Col>
                    <Col className="form" md={12} sm={15} xs={24}>
                        <Card title="Платежная информация:" bordered={false}>
                            <a className="profile-edit-button" onClick={() => this.toogleEdit('billingEdit')}>
                                { meta.success ? (
                                    <Fragment>
                                        <Icon type='edit' /> Редактировать
                                    </Fragment>
                                ) : 'Добавить' }
                            </a>
                            { billingEdit ? (
                                <ProfileBillingForm
                                    initialValues={{
                                        isIndividual: this.isIndividual(),
                                        ...billing_info
                                    }}
                                    isEdit={meta.success}
                                    isIndividual={this.isIndividual()}
                                    onSuccess={this.onSuccess}
                                />
                            ) : (billing_info && meta.success && (
                                <Fragment>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            ИНН
                                        </Col>
                                        <Col xs={12}>
                                            {billing_info.inn}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Банк
                                        </Col>
                                        <Col xs={12}>
                                            {billing_info.bank}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Р/С
                                        </Col>
                                        <Col xs={12}>
                                            {billing_info.checking_account}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            БИК
                                        </Col>
                                        <Col xs={12}>
                                            {billing_info.bic}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            КПП
                                        </Col>
                                        <Col xs={12}>
                                            {billing_info.cpp}
                                        </Col>
                                    </Row>
                                    <Row className="card-info">
                                        <Col className="card-info-label" xs={12}>
                                            Кор. счет
                                        </Col>
                                        <Col xs={12}>
                                            {billing_info.corr_account}
                                        </Col>
                                    </Row>
                                    { billing_info.snils && (
                                        <Row className="card-info">
                                            <Col className="card-info-label" xs={12}>
                                                СНИЛС
                                            </Col>
                                            <Col xs={12}>
                                                {billing_info.snils}
                                            </Col>
                                        </Row>
                                    )}
                                    { billing_info.inn_bank && (
                                        <Row className="card-info">
                                            <Col className="card-info-label" xs={12}>
                                                ИНН Банка
                                            </Col>
                                            <Col xs={12}>
                                                {billing_info.inn_bank}
                                            </Col>
                                        </Row>
                                    )}
                                </Fragment>
                            )) || 'Нет данных'}
                        </Card>
                    </Col>
                </Row>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/profile/Profile.js